import {Injectable} from '@angular/core';
import {BusinessDataService} from '../data-repositories/business-data.service';
import {User} from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerService {

  isInit = false;
  isSubmitted = false;

  constructor(private businessDataService: BusinessDataService) {

  }

  init(): void {
    this.businessDataService.getGTM(x => {
      if (x.id) {
        this.isInit = true;

        const script = document.createElement('script');
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${x.id}');`;
        document.head.appendChild(script);

        const iframe = document.createElement('iframe');
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${x.id}`;
        iframe.height = `0`;
        iframe.width = `0`;
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';

        const noscript = document.createElement('noscript');
        noscript.appendChild(iframe);
        document.body.appendChild(noscript);
      }
    });
  }

  submit(user: User) {
    if (this.isInit && !this.isSubmitted) {
      this.isSubmitted = true;

      const script = document.createElement('script');
      script.innerHTML = `dataLayer.push({
        'event':'ec_formsubmit',
        'enhanced_conversion_data': {
          "phone_number": '+${user.phone}'
        }
      })`;

      document.head.appendChild(script);
    }
  }

}
